import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcSorting(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.222 3.22a.75.75 0 0 1 1.06 0l3.495 3.494a.75.75 0 0 1-1.06 1.061l-2.215-2.214V19.27a.75.75 0 0 1-1.5 0V5.56l-2.214 2.215a.75.75 0 0 1-1.06-1.06zm-8.97.753a.75.75 0 0 1 .75.75v13.716l2.22-2.219a.75.75 0 1 1 1.06 1.06l-3.5 3.5a.75.75 0 0 1-1.06 0l-3.5-3.5a.75.75 0 1 1 1.061-1.06l2.22 2.22V4.722a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  }));
}
var IcSorting = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSorting));

export { IcSorting as I };
